import React from "react";
import { Helmet } from "react-helmet-async";

import { getProductData, getProductNameBy } from "../../services/productService";
import InitialStatusBox from "./StatusBox/InitialStatusBox";
import InitialProcessBox from "./ProcessBox/InitialProcessBox";
import { Box } from "@mui/material";
import ServiceWorldInitialCaseProductBoxes from "./ServiceWorldCase/ServiceWorldInitialCaseProductBoxes";
import useProductParams from "../../hooks/useProductParams";
import { gaSet } from "../../services/googleAnalyticsService";
import ProductStatus from "@/src/components/ProductStatus/ProductStatus";

const ServiceWorldInitialCase = () => {
  const { productName } = useProductParams();
  const productClassName = getProductNameBy("urlPartShort", productName);

  const title = "Servicewelt Mein Fall | Legalbird";
  gaSet({ title: title });

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <ProductStatus headline={getProductData(productClassName, "label")}>
        <InitialStatusBox productClassName={productClassName} />
      </ProductStatus>
      <Box id={"status"} />
      <InitialProcessBox productClassName={productClassName} />
      <ServiceWorldInitialCaseProductBoxes
        product={{
          name: productClassName,
        }}
      />
    </>
  );
};

export default ServiceWorldInitialCase;
